/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var ValidationRequirementStatus;

(function (ValidationRequirementStatus) {
  ValidationRequirementStatus["FAIL"] = "fail";
  ValidationRequirementStatus["PENDING"] = "pending";
  ValidationRequirementStatus["SUCCESS"] = "success";
  ValidationRequirementStatus["NOT_STARTED"] = "not_started";
})(ValidationRequirementStatus || (ValidationRequirementStatus = {}));